import { createSlice } from "@reduxjs/toolkit";
const storeMenuUrl = createSlice({
    name: "store_assign_url",
    initialState: { menuUrl: [] },
    reducers: {
        storeMenu: (state, action) => {
            state.menuUrl = action.payload;
        },
    },
});
export const { storeMenu } = storeMenuUrl.actions;
export default storeMenuUrl.reducer;
